import { X } from "lucide-react";
import { FC } from "react";
import { useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";

type Props = {
  keys: string[];
};

export const ClearFilters: FC<Props> = ({ keys }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const hasActiveFilters = keys.some((key) => searchParams.has(key));

  const handleClearFilters = () => {
    const params = new URLSearchParams(searchParams);

    for (const key of keys) {
      params.delete(key);
    }

    setSearchParams(params);
  };

  if (!hasActiveFilters) return null;

  return (
    <Button variant="outline" onClick={handleClearFilters}>
      <X /> Clear
    </Button>
  );
};
